import { PROFILE_DETAILS, VIEW_USER_DETAILS } from './types'
import { getItem } from '../../utils/localstorage'

const initialState = {
  view_details: [],
  profile_details: JSON.parse(getItem('userData')),
}

const user = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case VIEW_USER_DETAILS:
      return {
        ...state,
        view_details: payload,
      }
    case PROFILE_DETAILS:
      return {
        ...state,
        profile_details: payload,
      }

    default:
      return state
  }
}

export default user
